export const CommandPaletteTestIds = {
  ROOT: 'command-palette.dialog',
  getResult: id => `command-palette.result-${id}`,
};
